import { thunk } from "redux-thunk";
import { bookingReducer } from "./Booking/Reducer";
import { applyMiddleware, combineReducers, legacy_createStore } from "redux";
import { stateReducer } from "./State/Reducer";
import { workerReducer } from "./Worker/Reducer";
import { washReducer } from "./Wash/Reducer";
import { contactUsReducer } from "./ContactUs/Reducer";
import { reviewsReducer } from "./Reviews/Reducer";
import { authReducer } from "./Auth/Reducer";
import { loggedInUserReducer } from "./LoggedInUser/Reducer";
import { estimatedPriceReducer } from "./EstimatedPrice/Reducer";
import { cityReducer } from "./City/Reducer";
import { expenseReducer } from "./Expense/Reducer";
import { dbHealthCheckReducer } from "./DBHealthCheck/Reducer";
import { exceptionLogReducer } from "./ExceptionLog/Reducer";
import { bookingSlotReducer } from "./BookingSlot/Reducer";
import { salaryReducer } from "./Salary/Reducer";
import { washCentreReducer } from "./WashCentre/Reducer";
import { centreBookingReducer } from "./CentreBooking/Reducer";

const rootReducers = combineReducers({
  booking: bookingReducer,
  state: stateReducer,
  worker: workerReducer,
  wash: washReducer,
  contactUs: contactUsReducer,
  review: reviewsReducer,
  auth: authReducer,
  loggedInUsers: loggedInUserReducer,
  estimatedPrice: estimatedPriceReducer,
  city: cityReducer,
  expense: expenseReducer,
  dbHealthCheck: dbHealthCheckReducer,
  exceptionLog: exceptionLogReducer,
  bookingSlot: bookingSlotReducer,
  salary: salaryReducer,
  washCentre: washCentreReducer,
  centreBooking: centreBookingReducer,
});

export const store = legacy_createStore(rootReducers, applyMiddleware(thunk));
